import { render, staticRenderFns } from "./RbuItemList.vue?vue&type=template&id=421892da&scoped=true"
import script from "./RbuItemList.vue?vue&type=script&lang=js"
export * from "./RbuItemList.vue?vue&type=script&lang=js"
import style0 from "./RbuItemList.vue?vue&type=style&index=0&id=421892da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421892da",
  null
  
)

export default component.exports